/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AiLifecycleDashboardContent } from '../model';
// @ts-ignore
import type { DocumentOverview } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { PageControl } from '../model';
// @ts-ignore
import type { PageDocumentOverview } from '../model';
// @ts-ignore
import type { PagePlatformControlDetailed } from '../model';
// @ts-ignore
import type { PagePlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { PagePlatformRequirementDetailed } from '../model';
// @ts-ignore
import type { PageVendorDetails } from '../model';
// @ts-ignore
import type { PlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { Project } from '../model';
// @ts-ignore
import type { ProjectAiSystemLifecycleDashboard } from '../model';
// @ts-ignore
import type { ProjectFrameworksFreezeUpdate } from '../model';
// @ts-ignore
import type { Status } from '../model';
// @ts-ignore
import type { VendorData } from '../model';
// @ts-ignore
import type { VendorDetails } from '../model';
/**
 * V1Api - axios parameter creator
 */
export const V1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Vendor
         * @param {string} organizationId 
         * @param {VendorData} vendorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorV1OrganizationsOrganizationIdVendorsPost: async (organizationId: string, vendorData: VendorData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createVendorV1OrganizationsOrganizationIdVendorsPost', 'organizationId', organizationId)
            // verify required parameter 'vendorData' is not null or undefined
            assertParamExists('createVendorV1OrganizationsOrganizationIdVendorsPost', 'vendorData', vendorData)
            const localVarPath = `/v1/organizations/{organization_id}/vendors`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vendorData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Document
         * @param {string} vendorId 
         * @param {string} documentId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete: async (vendorId: string, documentId: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete', 'vendorId', vendorId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete', 'documentId', documentId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}/documents/{document_id}`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete: async (vendorId: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete', 'vendorId', vendorId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Vendor Document
         * @param {string} vendorId 
         * @param {string} documentId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet: async (vendorId: string, documentId: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet', 'vendorId', vendorId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet', 'documentId', documentId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}/documents/{document_id}/download`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Project
         * @param {string} projectId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectV1ProjectsProjectIdExportPost: async (projectId: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('exportProjectV1ProjectsProjectIdExportPost', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/export`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeZone !== undefined) {
                localVarQueryParameter['time_zone'] = timeZone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {string} projectId 
         * @param {ProjectFrameworksFreezeUpdate} projectFrameworksFreezeUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch: async (projectId: string, projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch', 'projectId', projectId)
            // verify required parameter 'projectFrameworksFreezeUpdate' is not null or undefined
            assertParamExists('freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch', 'projectFrameworksFreezeUpdate', projectFrameworksFreezeUpdate)
            const localVarPath = `/v1/projects/{project_id}/freeze-frameworks-update`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectFrameworksFreezeUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {string} projectId 
         * @param {AiLifecycleDashboardContent} [dashboardContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet: async (projectId: string, dashboardContent?: AiLifecycleDashboardContent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/ai_system_life_cycle_dashboard`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dashboardContent !== undefined) {
                localVarQueryParameter['dashboard_content'] = dashboardContent;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Framework In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet: async (frameworkCode: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet: async (frameworkCode: string, version: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'version', version)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/versions/{version}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{version}', encodeURIComponent(String(version)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/versions`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/controls`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet: async (frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/frameworks/{framework_code}/requirements`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Status | null} [status] Filter by control status
         * @param {string | null} [name] 
         * @param {Array<string> | null} [controlIds] Filter by control ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsV1ProjectsProjectIdControlsGet: async (projectId: string, page?: number, size?: number, status?: Status | null, name?: string | null, controlIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectControlsV1ProjectsProjectIdControlsGet', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/controls`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (controlIds) {
                localVarQueryParameter['control_ids'] = controlIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet: async (vendorId: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet', 'vendorId', vendorId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Documents For Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {string | null} [name] Filter by name
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet: async (vendorId: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet', 'vendorId', vendorId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}/documents`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Vendors
         * @param {string} organizationId 
         * @param {string | null} [name] Filter by name
         * @param {string | null} [vendorType] Filter by vendor type
         * @param {string | null} [vendorStatus] Filter by vendor status
         * @param {string | null} [vendorRiskLevel] Filter by vendor risk level
         * @param {string | null} [reviewDate] Filter by review date
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendorsV1OrganizationsOrganizationIdVendorsGet: async (organizationId: string, name?: string | null, vendorType?: string | null, vendorStatus?: string | null, vendorRiskLevel?: string | null, reviewDate?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listVendorsV1OrganizationsOrganizationIdVendorsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/vendors`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (vendorType !== undefined) {
                localVarQueryParameter['vendor_type'] = vendorType;
            }

            if (vendorStatus !== undefined) {
                localVarQueryParameter['vendor_status'] = vendorStatus;
            }

            if (vendorRiskLevel !== undefined) {
                localVarQueryParameter['vendor_risk_level'] = vendorRiskLevel;
            }

            if (reviewDate !== undefined) {
                localVarQueryParameter['review_date'] = reviewDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/frameworks-update`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {VendorData} vendorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut: async (vendorId: string, organizationId: string, vendorData: VendorData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut', 'vendorId', vendorId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut', 'organizationId', organizationId)
            // verify required parameter 'vendorData' is not null or undefined
            assertParamExists('updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut', 'vendorData', vendorData)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vendorData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Document For Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [fileName] The file name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost: async (vendorId: string, organizationId: string, file: File, fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost', 'vendorId', vendorId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost', 'file', file)
            const localVarPath = `/v1/organizations/{organization_id}/vendors/{vendor_id}/documents`
                .replace('{vendor_id}', encodeURIComponent(String(vendorId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['file_name'] = fileName;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1Api - functional programming interface
 */
export const V1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Vendor
         * @param {string} organizationId 
         * @param {VendorData} vendorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVendorV1OrganizationsOrganizationIdVendorsPost(organizationId: string, vendorData: VendorData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVendorV1OrganizationsOrganizationIdVendorsPost(organizationId, vendorData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createVendorV1OrganizationsOrganizationIdVendorsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Document
         * @param {string} vendorId 
         * @param {string} documentId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(vendorId: string, documentId: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(vendorId, documentId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(vendorId: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(vendorId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download Vendor Document
         * @param {string} vendorId 
         * @param {string} documentId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(vendorId: string, documentId: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(vendorId, documentId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Project
         * @param {string} projectId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProjectV1ProjectsProjectIdExportPost(projectId: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProjectV1ProjectsProjectIdExportPost(projectId, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.exportProjectV1ProjectsProjectIdExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {string} projectId 
         * @param {ProjectFrameworksFreezeUpdate} projectFrameworksFreezeUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(projectId: string, projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(projectId, projectFrameworksFreezeUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {string} projectId 
         * @param {AiLifecycleDashboardContent} [dashboardContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(projectId: string, dashboardContent?: AiLifecycleDashboardContent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectAiSystemLifecycleDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(projectId, dashboardContent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Framework In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(frameworkCode: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(frameworkCode, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode: string, version: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode, version, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformControlDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {string} frameworkCode 
         * @param {string} organizationId 
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(frameworkCode: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePlatformRequirementDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(frameworkCode, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Status | null} [status] Filter by control status
         * @param {string | null} [name] 
         * @param {Array<string> | null} [controlIds] Filter by control ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectControlsV1ProjectsProjectIdControlsGet(projectId: string, page?: number, size?: number, status?: Status | null, name?: string | null, controlIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageControl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectControlsV1ProjectsProjectIdControlsGet(projectId, page, size, status, name, controlIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getProjectControlsV1ProjectsProjectIdControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(vendorId: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(vendorId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Documents For Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {string | null} [name] Filter by name
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(vendorId: string, organizationId: string, name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDocumentOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(vendorId, organizationId, name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Vendors
         * @param {string} organizationId 
         * @param {string | null} [name] Filter by name
         * @param {string | null} [vendorType] Filter by vendor type
         * @param {string | null} [vendorStatus] Filter by vendor status
         * @param {string | null} [vendorRiskLevel] Filter by vendor risk level
         * @param {string | null} [reviewDate] Filter by review date
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVendorsV1OrganizationsOrganizationIdVendorsGet(organizationId: string, name?: string | null, vendorType?: string | null, vendorStatus?: string | null, vendorRiskLevel?: string | null, reviewDate?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageVendorDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVendorsV1OrganizationsOrganizationIdVendorsGet(organizationId, name, vendorType, vendorStatus, vendorRiskLevel, reviewDate, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.listVendorsV1OrganizationsOrganizationIdVendorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {VendorData} vendorData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(vendorId: string, organizationId: string, vendorData: VendorData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(vendorId, organizationId, vendorData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Document For Vendor
         * @param {string} vendorId 
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [fileName] The file name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(vendorId: string, organizationId: string, file: File, fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(vendorId, organizationId, file, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * V1Api - factory interface
 */
export const V1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Vendor
         * @param {V1ApiCreateVendorV1OrganizationsOrganizationIdVendorsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorV1OrganizationsOrganizationIdVendorsPost(requestParameters: V1ApiCreateVendorV1OrganizationsOrganizationIdVendorsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDetails> {
            return localVarFp.createVendorV1OrganizationsOrganizationIdVendorsPost(requestParameters.organizationId, requestParameters.vendorData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Document
         * @param {V1ApiDeleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(requestParameters: V1ApiDeleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(requestParameters.vendorId, requestParameters.documentId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Vendor
         * @param {V1ApiDeleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(requestParameters: V1ApiDeleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(requestParameters.vendorId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Vendor Document
         * @param {V1ApiDownloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(requestParameters: V1ApiDownloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(requestParameters.vendorId, requestParameters.documentId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Project
         * @param {V1ApiExportProjectV1ProjectsProjectIdExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectV1ProjectsProjectIdExportPost(requestParameters: V1ApiExportProjectV1ProjectsProjectIdExportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportProjectV1ProjectsProjectIdExportPost(requestParameters.projectId, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {V1ApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters: V1ApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters.projectId, requestParameters.projectFrameworksFreezeUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {V1ApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters: V1ApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectAiSystemLifecycleDashboard> {
            return localVarFp.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters.projectId, requestParameters.dashboardContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Framework In Organization
         * @param {V1ApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters: V1ApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters.frameworkCode, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Framework Version In Organization
         * @param {V1ApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: V1ApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Framework Versions In Organization
         * @param {V1ApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters: V1ApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformFrameworkVersionOverview> {
            return localVarFp.getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
         * @summary Get Platform Framework Controls
         * @param {V1ApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters: V1ApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformControlDetailed> {
            return localVarFp.getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
         * @summary Get Platform Framework Requirements
         * @param {V1ApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters: V1ApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagePlatformRequirementDetailed> {
            return localVarFp.getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {V1ApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters: V1ApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageControl> {
            return localVarFp.getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.status, requestParameters.name, requestParameters.controlIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Vendor
         * @param {V1ApiGetVendorV1OrganizationsOrganizationIdVendorsVendorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(requestParameters: V1ApiGetVendorV1OrganizationsOrganizationIdVendorsVendorIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDetails> {
            return localVarFp.getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(requestParameters.vendorId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Documents For Vendor
         * @param {V1ApiListDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(requestParameters: V1ApiListDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageDocumentOverview> {
            return localVarFp.listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(requestParameters.vendorId, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Vendors
         * @param {V1ApiListVendorsV1OrganizationsOrganizationIdVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVendorsV1OrganizationsOrganizationIdVendorsGet(requestParameters: V1ApiListVendorsV1OrganizationsOrganizationIdVendorsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageVendorDetails> {
            return localVarFp.listVendorsV1OrganizationsOrganizationIdVendorsGet(requestParameters.organizationId, requestParameters.name, requestParameters.vendorType, requestParameters.vendorStatus, requestParameters.vendorRiskLevel, requestParameters.reviewDate, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {V1ApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters: V1ApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Vendor
         * @param {V1ApiUpdateVendorV1OrganizationsOrganizationIdVendorsVendorIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(requestParameters: V1ApiUpdateVendorV1OrganizationsOrganizationIdVendorsVendorIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDetails> {
            return localVarFp.updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(requestParameters.vendorId, requestParameters.organizationId, requestParameters.vendorData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Document For Vendor
         * @param {V1ApiUploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(requestParameters: V1ApiUploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentOverview> {
            return localVarFp.uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(requestParameters.vendorId, requestParameters.organizationId, requestParameters.file, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createVendorV1OrganizationsOrganizationIdVendorsPost operation in V1Api.
 */
export interface V1ApiCreateVendorV1OrganizationsOrganizationIdVendorsPostRequest {
    readonly organizationId: string

    readonly vendorData: VendorData
}

/**
 * Request parameters for deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete operation in V1Api.
 */
export interface V1ApiDeleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDeleteRequest {
    readonly vendorId: string

    readonly documentId: string

    readonly organizationId: string
}

/**
 * Request parameters for deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete operation in V1Api.
 */
export interface V1ApiDeleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDeleteRequest {
    readonly vendorId: string

    readonly organizationId: string
}

/**
 * Request parameters for downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet operation in V1Api.
 */
export interface V1ApiDownloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGetRequest {
    readonly vendorId: string

    readonly documentId: string

    readonly organizationId: string
}

/**
 * Request parameters for exportProjectV1ProjectsProjectIdExportPost operation in V1Api.
 */
export interface V1ApiExportProjectV1ProjectsProjectIdExportPostRequest {
    readonly projectId: string

    readonly timeZone?: string
}

/**
 * Request parameters for freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch operation in V1Api.
 */
export interface V1ApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest {
    readonly projectId: string

    readonly projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate
}

/**
 * Request parameters for getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet operation in V1Api.
 */
export interface V1ApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest {
    readonly projectId: string

    readonly dashboardContent?: AiLifecycleDashboardContent
}

/**
 * Request parameters for getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet operation in V1Api.
 */
export interface V1ApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string
}

/**
 * Request parameters for getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet operation in V1Api.
 */
export interface V1ApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest {
    readonly frameworkCode: string

    readonly version: string

    readonly organizationId: string
}

/**
 * Request parameters for getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet operation in V1Api.
 */
export interface V1ApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet operation in V1Api.
 */
export interface V1ApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet operation in V1Api.
 */
export interface V1ApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest {
    readonly frameworkCode: string

    readonly organizationId: string

    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getProjectControlsV1ProjectsProjectIdControlsGet operation in V1Api.
 */
export interface V1ApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    /**
     * Filter by control status
     */
    readonly status?: Status | null

    readonly name?: string | null

    /**
     * Filter by control ids
     */
    readonly controlIds?: Array<string> | null
}

/**
 * Request parameters for getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet operation in V1Api.
 */
export interface V1ApiGetVendorV1OrganizationsOrganizationIdVendorsVendorIdGetRequest {
    readonly vendorId: string

    readonly organizationId: string
}

/**
 * Request parameters for listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet operation in V1Api.
 */
export interface V1ApiListDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGetRequest {
    readonly vendorId: string

    readonly organizationId: string

    /**
     * Filter by name
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for listVendorsV1OrganizationsOrganizationIdVendorsGet operation in V1Api.
 */
export interface V1ApiListVendorsV1OrganizationsOrganizationIdVendorsGetRequest {
    readonly organizationId: string

    /**
     * Filter by name
     */
    readonly name?: string | null

    /**
     * Filter by vendor type
     */
    readonly vendorType?: string | null

    /**
     * Filter by vendor status
     */
    readonly vendorStatus?: string | null

    /**
     * Filter by vendor risk level
     */
    readonly vendorRiskLevel?: string | null

    /**
     * Filter by review date
     */
    readonly reviewDate?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost operation in V1Api.
 */
export interface V1ApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest {
    readonly projectId: string
}

/**
 * Request parameters for updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut operation in V1Api.
 */
export interface V1ApiUpdateVendorV1OrganizationsOrganizationIdVendorsVendorIdPutRequest {
    readonly vendorId: string

    readonly organizationId: string

    readonly vendorData: VendorData
}

/**
 * Request parameters for uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost operation in V1Api.
 */
export interface V1ApiUploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPostRequest {
    readonly vendorId: string

    readonly organizationId: string

    readonly file: File

    /**
     * The file name.
     */
    readonly fileName?: string
}

/**
 * V1Api - object-oriented interface
 */
export class V1Api extends BaseAPI {
    /**
     * 
     * @summary Create Vendor
     * @param {V1ApiCreateVendorV1OrganizationsOrganizationIdVendorsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createVendorV1OrganizationsOrganizationIdVendorsPost(requestParameters: V1ApiCreateVendorV1OrganizationsOrganizationIdVendorsPostRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createVendorV1OrganizationsOrganizationIdVendorsPost(requestParameters.organizationId, requestParameters.vendorData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Document
     * @param {V1ApiDeleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(requestParameters: V1ApiDeleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).deleteDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDelete(requestParameters.vendorId, requestParameters.documentId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Vendor
     * @param {V1ApiDeleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(requestParameters: V1ApiDeleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).deleteVendorV1OrganizationsOrganizationIdVendorsVendorIdDelete(requestParameters.vendorId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Vendor Document
     * @param {V1ApiDownloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(requestParameters: V1ApiDownloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).downloadVendorDocumentV1OrganizationsOrganizationIdVendorsVendorIdDocumentsDocumentIdDownloadGet(requestParameters.vendorId, requestParameters.documentId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Project
     * @param {V1ApiExportProjectV1ProjectsProjectIdExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportProjectV1ProjectsProjectIdExportPost(requestParameters: V1ApiExportProjectV1ProjectsProjectIdExportPostRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).exportProjectV1ProjectsProjectIdExportPost(requestParameters.projectId, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
     * @summary Freeze Project Frameworks Update
     * @param {V1ApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters: V1ApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters.projectId, requestParameters.projectFrameworksFreezeUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
     * @summary Get Ai System Life Cycle Dashboard
     * @param {V1ApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters: V1ApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters.projectId, requestParameters.dashboardContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Framework In Organization
     * @param {V1ApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters: V1ApiGetFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getFrameworkInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeGet(requestParameters.frameworkCode, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Framework Version In Organization
     * @param {V1ApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: V1ApiGetFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getFrameworkVersionInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Framework Versions In Organization
     * @param {V1ApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters: V1ApiGetFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getFrameworkVersionsInOrganizationV1OrganizationsOrganizationIdFrameworksFrameworkCodeVersionsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework controls.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformControlDetailed]: The requirements.
     * @summary Get Platform Framework Controls
     * @param {V1ApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters: V1ApiGetPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPlatformFrameworkControlsV1OrganizationsOrganizationIdFrameworksFrameworkCodeControlsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all platform framework requirements.  Args:     db (Session): The database session.  Returns:     Page[schemas.PlatformRequirementDetailed]: The requirements.
     * @summary Get Platform Framework Requirements
     * @param {V1ApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters: V1ApiGetPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPlatformFrameworkRequirementsV1OrganizationsOrganizationIdFrameworksFrameworkCodeRequirementsGet(requestParameters.frameworkCode, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Controls
     * @param {V1ApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters: V1ApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.status, requestParameters.name, requestParameters.controlIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Vendor
     * @param {V1ApiGetVendorV1OrganizationsOrganizationIdVendorsVendorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(requestParameters: V1ApiGetVendorV1OrganizationsOrganizationIdVendorsVendorIdGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getVendorV1OrganizationsOrganizationIdVendorsVendorIdGet(requestParameters.vendorId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Documents For Vendor
     * @param {V1ApiListDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(requestParameters: V1ApiListDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).listDocumentsForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsGet(requestParameters.vendorId, requestParameters.organizationId, requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Vendors
     * @param {V1ApiListVendorsV1OrganizationsOrganizationIdVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listVendorsV1OrganizationsOrganizationIdVendorsGet(requestParameters: V1ApiListVendorsV1OrganizationsOrganizationIdVendorsGetRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).listVendorsV1OrganizationsOrganizationIdVendorsGet(requestParameters.organizationId, requestParameters.name, requestParameters.vendorType, requestParameters.vendorStatus, requestParameters.vendorRiskLevel, requestParameters.reviewDate, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
     * @summary Project Frameworks Update
     * @param {V1ApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters: V1ApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Vendor
     * @param {V1ApiUpdateVendorV1OrganizationsOrganizationIdVendorsVendorIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(requestParameters: V1ApiUpdateVendorV1OrganizationsOrganizationIdVendorsVendorIdPutRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateVendorV1OrganizationsOrganizationIdVendorsVendorIdPut(requestParameters.vendorId, requestParameters.organizationId, requestParameters.vendorData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Document For Vendor
     * @param {V1ApiUploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(requestParameters: V1ApiUploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).uploadDocumentForVendorV1OrganizationsOrganizationIdVendorsVendorIdDocumentsPost(requestParameters.vendorId, requestParameters.organizationId, requestParameters.file, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }
}

